import workspaceQuery from 'graphql/queries/sales/SalesOrderAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SalesOrderAuditByField = {
  type: 'AuditChange',
  formTitle: 'Sales Order Audit',
  formUrl: '/Sales/SalesOrderAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Sales',
  screenReference: 'SALES_ORDER_AUDIT',
  operations: ALLOW_VIEW,
};

export default SalesOrderAuditByField;
